<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title primary-title class='white white--text py-1 justify-center'>
          <div class="pl-1">
            <span class="title-card">Extrato 🗃️</span>
          </div>
          <v-spacer></v-spacer>
          <v-btn color="black" icon class="mr-n3 ml-3 title-financial" @click="$emit('closeExtract')"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table :loading="loading_data" :footer-props="{'items-per-page-options':[5,10,15,30]}" :items-per-page="5" :headers="headers" :items="api_data"  item-key="id" class="pt-5" :options.sync="options" :server-items-length="total_data">

            <template v-slot:item.due_date="{ item }">
              {{ $dayjs(item.due_date).add(12, 'h').format('DD/MM/YYYY') }}
            </template>

            <template v-slot:item.value="{ item }">
              <span :class="item.account_kind == 'current' ? kind_map[item.kind].text_color : 'primary--text'">
                {{ formatMoney((item.value / 100).toString()) }}
              </span>
              <v-icon size='20' class="mb-1" color='primary' v-if="item.account_kind == 'savings'">{{item.kind == 'income'? 'mdi-cash-plus' : 'mdi-cash-minus'}}</v-icon>
            </template>

            <template v-slot:item.event_name="{ item }" class="pa-auto">
              {{item.event_name}}
              <v-btn v-if="item.event_id" color="normal" small icon @click="showEventOnClick(item.event_id)"><v-icon small>mdi-magnify</v-icon></v-btn>
            </template>

            <template v-slot:item.actions="{ item }" class="pa-auto">
              <v-btn  color="normal" small icon @click="showMovementOnClick(item)"><v-icon small>mdi-pencil</v-icon></v-btn>
            </template>

          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <dialog-show-movement v-if="dialog_movement" @closeDialog="handleClose" @doneDialog="handleDone" :movement_to_edit="movement_item"></dialog-show-movement>
  </div>
</template>

<script>
  import table_pagination from "@/mixins/table_pagination";
  import { mapState, mapActions, mapGetters } from 'vuex'
  export default {
    name: 'MovementsExtract',
    components: {
      DialogShowMovement: () => import('../shared/DialogShowMovement.vue'),
    },
    props: {
      dialog: {
        type: Boolean,
        default: false
      }
    },
    mixins: [
      table_pagination
    ],
    data() {
      return {
        kind_map: {
          income: {
            text_color: 'green--text',
            icon: '',
            text: 'Entrada'
          },
          outcome: {
            text_color: 'red--text',
            icon: '',
            text: 'Saída'
          },
          withdraw: {
            text_color: 'orange--text',
            icon: '',
            text: 'Retirada'
          },
        },
        movement_item: {},
        dialog_movement: false,
      }
    },
    methods: {
      handleClose(){
        this.dialog_movement = false
        this.movement_item = {}
      },
      handleDone(){
        this.dialog_movement = false
        this.movement_item = {}
        this.reloadMovement()
      },
      reloadMovement(){
        this.$emit('reloadTable')
      },
      showEventOnClick(event_id){
        let route = this.$router.resolve({name: 'ShowEvent', params: {id: event_id}})
        window.open(route.href, '_blank')
      },
      showMovementOnClick(item){
        this.movement_item = {...item, due_date: this.$dayjs(item.due_date).format('YYYY-MM-DD')}     
        this.dialog_movement = true
      },
      formatMoney(entry){
        return Number(entry).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
      },
      getData(){
        this.getDataFromApi('Extract', 'index')
      }
    },

    mounted () {
      this.getData()
    },
    
    computed: {
      headers () {
        return [
          {
            text: 'VENC.',
            align: 'center',
            value: 'due_date',
          },
          {
            text: 'EVENTO',
            value: 'event_name',
          },
          {
            text: 'DESC.',
            value: 'name',
          },
          { 
            text: 'VALOR',
            value: 'value',
          },
          { 
            text: 'AÇÕES',
            value: 'actions',
            sortable: false,
          },
        ]
      },
      ...mapState({
        activeCompanyId: state => state.App.activeCompanyId
      }),
    },
    watch: {
      activeCompanyId(){
        this.getData()
      }
    },

  }
</script>

<style lang="scss">
</style>